const LayoutWrapper = ({ condition, wrapper, children }) => {
  if (condition) {
    return wrapper(children);
  }
  return children;
};

export default LayoutWrapper;
